import {fetchBaseQuery} from "@reduxjs/toolkit/query/react";

const {VITE_APP_API_BASE_URL} = import.meta.env;

export const platformAuthConfig = () => {
  return {
    baseQuery: fetchBaseQuery({
      baseUrl: `${VITE_APP_API_BASE_URL}/v1`,
      credentials: "include",
      prepareHeaders: (headers, {getState}) => {
        const token = (getState() as {userState: {platformBearer: string}})
          .userState.platformBearer;
        if (token) {
          headers.set("authorization", `Bearer ${token}`);
        }
        return headers;
      },
    }),
    keepUnusedDataFor: 20,
    refetchOnMountOrArgChange: true,
  };
};

export const authConfig = () => {
  return {
    baseQuery: fetchBaseQuery({
      baseUrl: `${VITE_APP_API_BASE_URL}`,
      credentials: "include",
      prepareHeaders: (headers) => {
        headers.set("Content-Type", "application/json");
        return headers;
      },
    }),
    keepUnusedDataFor: 20,
    refetchOnMountOrArgChange: true,
  };
};

export default platformAuthConfig;
